import { useState } from "react";
import Link from "components/base/Link";
import Trans from "components/base/Trans";
import Image from "components/base/Image";
import Date from "components/blog/Date";
import Text from "components/base/Text";
import { MotionBox as Box, MotionFlex as Flex, hoverScaleVariants } from "utils/motion";
import Play from "components/icons/Play";

const hoverOpacityVariants = {
  hovered: { opacity: 1, transition: { type: "tween", duration: 0.5 } },
  regular: { opacity: 0, transition: { type: "tween", duration: 0.5 } },
};

const PostLink = ({ uid, type, data, ...props }) => {
  const [isHovered, setIsHovered] = useState(false);
  if (!data) {
    return null;
  }
  return (
    <Box
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      pb={["xs", "sm", "md", "lg"]}
      {...props}
    >
      <Link
        href={type === "episode" ? `/docuseries?id=${uid}` : `/blog/${uid}`}
        _hover={{ textDecoration: "none" }}
        _focus={{ boxShadow: "0px 0px 0px" }}
      >
        <Box overflow="hidden">
          <Box overflow="hidden" bg="gray.300" position="relative">
            <Flex
              position="absolute"
              bottom={3}
              alignItems="flex-end"
              justifyContent="space-between"
              px={3}
              zIndex={1}
              opacity={type === "episode" ? 1 : 0}
              width="100%"
            >
              {type === "episode" && (
                <Box>
                  <Text type="title_xxs" color="white">
                    <Trans id="LBL_DOCUSERIES_TITLE" />
                  </Text>
                  <Text type="title_md" color="white" fontWeight="500">
                    <Trans
                      id="LBL_EPISODE"
                      values={{ number: data.episode_number }}
                    />
                  </Text>
                </Box>
              )}
              <Play color="white" size="24px" />
            </Flex>
            <Box
              pt="52.6%"
              position="relative"
              variants={hoverScaleVariants}
              initial="regular"
              animate={isHovered ? "hovered" : "regular"}
            >
              <Image
                src={data.thumbnail.url}
                alt={data.thumbnail.alt}
                objectFit="cover"
                objectPosition="center"
                style={{ position: "absolute" }}
                top="0"
                bottom="0"
                left="0"
                right="0"
                sizes="(max-width: 768px) 100vw, 33vw"
              />
              <Box
                top="0"
                position="absolute"
                height="100%"
                width="100%"
                variants={hoverOpacityVariants}
                initial="regular"
                animate={isHovered ? "hovered" : "regular"}
              />
            </Box>
            <Box
              w="100%"
              h="100%"
              position="absolute"
              top={0}
              variants={hoverOpacityVariants}
              initial="regular"
              animate={type === "episode" ? "hovered" : "regular"}
              style={{
                backgroundImage:
                  "linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.1) 60%, rgba(0, 0, 0, 0.9))",
              }}
            />
          </Box>
          <Box pt={["xs", null, null, "sm"]}>
            <Text
              type="title_md"
              color={props.color}
              textTransform="none"
              letterSpacing={0}
            >
              {data.title[0].text}
            </Text>
            <Date date={data.published_date} mt={["xxs", null, null, "xs"]} />
          </Box>
        </Box>
      </Link>
    </Box>
  );
};

export default PostLink;
